/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var initPeek = function() {
  (function(config) {
    window._peekConfig = config || {};
    var idPrefix = 'peek-book-button';
    var id = idPrefix+'-js'; if (document.getElementById(id)) { return; }
    var head = document.getElementsByTagName('head')[0];
    var el = document.createElement('script'); el.id = id;
    var date = new Date(); var stamp = date.getMonth()+"-"+date.getDate();
    var basePath = "https://js.peek.com";
    el.src = basePath + "/widget_button.js?ts="+stamp;
    head.appendChild(el); id = idPrefix+'-css'; el = document.createElement('link'); el.id = id;
    el.href = basePath + "/widget_button.css?ts="+stamp;
    el.rel="stylesheet"; el.type="text/css"; head.appendChild(el);
  })({key: '3850cf80-d2b7-4738-91d7-29db24c07a13'});
};


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {

        // LOADING STEP: These things are required for load.
        $(function() {


          // **** We have 1 second to do everything in this step.
          
          $('body').deviceDetection();

          $('.module-video-hero').resizeHero({
            hero: '.module-video-hero__video',
            position: '.module-video-hero__video--position',
            element: '.module-video-hero__video--poster'
          });
          $('.page.scorpion-bay-grill .module-image-hero').resizeHero({
            hero: '.module-image-hero__background',
            position: '.module-image-hero__background--position',
            element: '.module-image-hero__image'
          });
          $('.module-video-hero').homeVideoController({
            video: '.module-video-hero__video--video',
            title: '.module-video-hero__html_body h1'
          });

          // Load the page via ajax so we can track the loading progress
          // once the ajax'd version loads, we can assume the page is
          // also loaded.
          $('.main-loading').progressBar({
            'bar': '.main-loading__loader--bar',
            'onComplete': function(e) {
              // All of this happens after the page is already loading in the idle period. Make sure
              // things the user will interact with first happen within 1 second of page load. Then
              // do the other stuff in the background afterwards.

              var hash = window.location.hash;
              if (hash && hash.length) {
                setTimeout(function() {
                  var $t = $(hash),
                      $h = $('.main-header'),
                      tt = $t.offset().top,
                      hh = $h.outerHeight(),
                      st = tt - (hh - 1);
                  $('html, body').animate({
                    scrollTop: st
                  }, 500);
                }, 2000);
              } else {
                window.scrollTo(0, 0);
              }
              
              $('.main-navigation').mainMenu({
                'trigger': '.main-header__toggle'
              });
              $('.side-navigation').sideMenu();

              // Everything with .lazy-bg should have .build-in
              $.unique($('.media')).mediaManager();


              $('.module-video-hero').first().stickyMenu({
                'header': '.main-header',
                'brand': '.main-header__brand',
                'background': '.module-video-hero__video',
                'cover': '.module-video-hero__cover',
                'content': '.module-video-hero__html_body',
                'scrollButton': '.module-video-hero__scroll-down'
              });
              $('.module-image-hero').first().stickyMenu({
                'header': '.main-header',
                'brand': '.main-header__brand',
                'background': '.module-image-hero__background',
                'cover': '.module-image-hero__cover',
                'content': '.module-image-hero__html_body',
                'scrollButton': '.module-image-hero__scroll-down'
              });
              $('.module-content-block').contentSection();

              $('.rental_element').rentalItem();

              $('.rotate-hero').heroRotator();
              $('.page.scorpion-bay-grill .menu-navigation__container').stickySubMenu();
              $('.page.rental-fleet .menu-navigation__container').stickySubMenu();
              $('.smooth').smoothScroll();

              $('.module-event-list').eventRotator();
              $('.image_rotator').imageRotator();

              $('.weather-bug').weatherBug();

              $('.overlay-faqs').overlayController();
              $('.overlay-gng').overlayController({
                'controller': new OverlayGngController($)
              });

              initPeek();
              // $('body').vquipOverlay();

              $('.module-announcements').announcementRotator();

              // Setup the form fields with the label hover effect
              // TODO: Possibly move this to it's own container method

              var nfi = 0,
                  nfInitField = function() {
                      var $f = $('.nf-form-cont .field-wrap').not('.submit-wrap');

                      if (!$f.length) {
                        if (nfi++ < 3) { setTimeout(nfInitField, 500); }
                      } else {
                        $f.formField();
                      }
                    }
              ;
              nfInitField();
            }
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },

    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },

    'floating_cabins' : {
      init: function() {
      }
    },

    'private_charter' : {
      init: function() {
      }
    },

    'private_events' : {
      init: function() {
      }
    },

    'rental_fleet' : {
      init: function() {
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
